import { cva } from 'class-variance-authority';

const calendarContainerBaseStyles = ['max-w-[400px]', 'shadow-md'];

const calendarContainerSAG = cva([
  ...calendarContainerBaseStyles,
  'bg-[#F3F3F0]',
  'dark:bg-[#23233C]',
]);

const calendarContainerSHS = cva([
  ...calendarContainerBaseStyles,
  'bg-white',
  'dark:bg-[#1a1a1a]',
]);

const calendarButtonSAG = cva([
  'text-[#007993]',
  'hover:bg-[#E8E8E3]',
  'dark:text-[#00CCCC]',
  'dark:hover:bg-[#37374D]',
]);

const calendarButtonSHS = cva([
  'text-[#666666]',
  'hover:text-[#1a1a1a]',
  'dark:text-[#999999]',
  'dark:hover:text-white',
]);

const calendarTopTextBaseStyles = ['text-md', 'font-medium'];

const calendarTopTextSAG = cva([
  ...calendarTopTextBaseStyles,
  'text-[#007993]',
  'dark:text-[#00CCCC]',
]);

const calendarTopTextSHS = cva([
  ...calendarTopTextBaseStyles,
  'text-[#666666]',
  'dark:text-[#999999]',
]);

const calendarDayTextBaseStyles = [
  'text-sm',
  'font-semibold',
  'select-none',
  'flex',
  'items-center',
  'justify-center',
  'aspect-square',
  'p-2',
];

const calendarDayTextSAG = cva([
  ...calendarDayTextBaseStyles,
  'text-[#000028]',
  'dark:text-white',
]);

const calendarDayTextSHS = cva([
  ...calendarDayTextBaseStyles,
  'text-[#666666]',
  'dark:text-[#999999]',
]);

const calendarDayBoxBaseStyles = [
  'text-sm',
  'cursor-pointer',
  'select-none',
  'flex',
  'items-center',
  'justify-center',
  'aspect-square',
  'p-2',
];

const calendarDisabledDayBoxSAG = cva([
  ...calendarDayBoxBaseStyles,
  'text-[#66667E]',
  'dark:text-[#9999A9]',
]);

const calendarDisabledDayBoxSHS = cva([
  ...calendarDayBoxBaseStyles,
  'text-[#999999]',
  'dark:text-[#666666]',
]);

const calendarDayBoxSAG = cva([
  ...calendarDayBoxBaseStyles,
  'dark:text-[#00CCCC]',
  'dark:hover:bg-[#37374D]',
  'dark:data-[selected=true]:bg-[#00FFB9]',
  'dark:data-[selected=true]:text-[#000028]',
  'dark:data-[selected=true]:font-semibold',
  'dark:data-[range=true]:bg-[#008C78]',
  'dark:data-[range=true]:text-[#000028]',
  'dark:data-[range=true]:font-semibold',

  'text-[#007993]',
  'hover:bg-[#E8E8E3]',
  'data-[selected=true]:bg-[#196269]',
  'data-[selected=true]:text-white',
  'data-[selected=true]:font-semibold',
  'data-[range=true]:bg-[#427E84]',
  'data-[range=true]:text-white',
  'data-[range=true]:font-semibold',
]);

const calendarDayBoxSHS = cva([
  ...calendarDayBoxBaseStyles,
  'dark:text-white',
  'dark:hover:bg-[#313131]',
  'dark:data-[selected=true]:bg-[#cf4b00]',
  'dark:data-[selected=true]:text-white',
  'dark:data-[selected=true]:font-semibold',

  'text-[#666666]',
  'hover:bg-[#E8E8E3]',
  'data-[selected=true]:bg-[#cf4b00]',
  'data-[selected=true]:text-white',
  'data-[selected=true]:font-semibold',
]);

const calendarMonthBoxBaseStyles = [
  'text-sm',
  'cursor-pointer',
  'select-none',
  'flex',
  'items-center',
  'justify-center',
  'p-4',
];

const calendarMonthBoxSAG = cva([
  ...calendarMonthBoxBaseStyles,
  'dark:text-[#00CCCC]',
  'dark:hover:bg-[#37374D]',
  'dark:data-[selected=true]:bg-[#00FFB9]',
  'dark:data-[selected=true]:text-[#000028]',
  'dark:data-[selected=true]:font-semibold',

  'text-[#007993]',
  'hover:bg-[#E8E8E3]',
  'data-[selected=true]:bg-[#196269]',
  'data-[selected=true]:text-white',
  'data-[selected=true]:font-semibold',
]);

const calendarMonthBoxSHS = cva([
  ...calendarMonthBoxBaseStyles,
  'dark:text-white',
  'dark:hover:bg-[#313131]',
  'dark:data-[selected=true]:bg-[#cf4b00]',
  'dark:data-[selected=true]:text-white',
  'dark:data-[selected=true]:font-semibold',

  'text-[#666666]',
  'hover:bg-[#E8E8E3]',
  'data-[selected=true]:bg-[#cf4b00]',
  'data-[selected=true]:text-white',
  'data-[selected=true]:font-semibold',
]);

const calendarTimeInputBaseStyles = [
  'border-none',
  'text-center',
  'text-md',
  'font-semibold',
  'p-2',
  'rounded-md',
  'w-[50px]',
  '[appearance:textfield]',
  '[&::-webkit-outer-spin-button]:appearance-none',
  '[&::-webkit-inner-spin-button]:appearance-none',
];

const calendarTimeInputSAG = cva([
  ...calendarTimeInputBaseStyles,
  'bg-[#E8E8E3]',
  'text-[#000028]',
  'dark:bg-[#37374D]',
  'dark:text-white',
]);

const calendarTimeInputSHS = cva([
  ...calendarTimeInputBaseStyles,
  'bg-white',
  'text-[#666666]',
  'dark:bg-[#1a1a1a]',
  'dark:text-[#999999]',
]);

const calendarTimeDividerBaseStyles = ['text-lg', 'font-bold'];

const calendarTimeDividerSAG = cva([
  ...calendarTimeDividerBaseStyles,
  'text-[#000028]',
  'dark:text-white',
]);

const calendarTimeDividerSHS = cva([
  ...calendarTimeDividerBaseStyles,
  'text-[#666666]',
  'dark:text-[#999999]',
]);

const calendarDividerSAG = cva(['border-[#E8E8E3]', 'dark:border-[#373750]']);

const calendarDividerSHS = cva(['border-[#666666]', 'dark:border-[#999999]']);

export {
  calendarContainerSAG,
  calendarContainerSHS,
  calendarButtonSAG,
  calendarButtonSHS,
  calendarTopTextSAG,
  calendarTopTextSHS,
  calendarDayTextSAG,
  calendarDayTextSHS,
  calendarDisabledDayBoxSAG,
  calendarDisabledDayBoxSHS,
  calendarDayBoxSAG,
  calendarDayBoxSHS,
  calendarMonthBoxSAG,
  calendarMonthBoxSHS,
  calendarTimeInputSAG,
  calendarTimeInputSHS,
  calendarTimeDividerSAG,
  calendarTimeDividerSHS,
  calendarDividerSAG,
  calendarDividerSHS,
};
